import React from 'react'
import { Dots } from 'react-activity'
import 'react-activity/dist/library.css'

const ActivityIndicator = () => (
    <Dots color='#0c537f' speed={0.5} />
)

export default ActivityIndicator